class Widget {
    constructor($el) {
        this.$el = $el;
        this.$widget = this.$el.find('[data-widget="widget"]');
        this.$button = this.$el.find('[data-widget="button"]');
        this.$id = this.$el.find('[data-widget-id]');
        this.html = $('html');
        this.body = $('body');
        this.isOpen = false;
        this.$closeButton = this.$el.find('[data-widget="close"]');
        this.$overlay = this.$el.find('[data-widget="overlay"]');
        this.init();
    }

    init = () => {
        this.$el.on('click', '[data-widget="button"]', this.clickHandler);
        this.$closeButton.on('click', this.close);
        this.$overlay.on('click', this.close);
    }

    clickHandler = (event) => {
        const $clickedButton = $(event.currentTarget);
        const roomNr = $clickedButton.data('room-nr');
        this.$id.attr('data-widget-id', roomNr);

        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }

    open = () => {
        this.html.addClass('no-scroll');


        const existingWidget = document.querySelector('.widget-root');
        if (existingWidget) existingWidget.remove();


        this.$widget.addClass('active');
        this.$overlay.addClass('active');
        this.isOpen = true;
    }

    close = () => {
        this.$widget.removeClass('active');
        this.$overlay.removeClass('active');
        this.html.removeClass('no-scroll');
        this.isOpen = false;
    };
}

export default Widget;
